export default {
  order: 1,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'CARBON_SEQ',
    order: 1,
    type: 'remoteDataLayer',
    uuid: 'e7208398-0acd-4f73-a824-c4fe1e356e0c',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        type: 'gradient',
        name: {
          en: 'Potential carbon sequestration rate',
          fr: 'Taux potentiel de séquestration du carbone',
          es: 'Tasa potencial de captura de carbono',
          pt: 'Taxa potencial de sequestro de carbono',
          id: 'Potensi tingkat penyerapan karbon',
          zh: '潜在的碳封存率',
          ka: 'Potential carbon sequestration rate',
        },
        source: '(reforestable areas, 1 km, Cook-Patton et al. 2020)',
        items: [
          {
            name: {
              zh: '6.0 Mg C Ha⁻¹ yr⁻¹',
              pt: '6.0 Mg C Ha⁻¹ yr⁻¹',
              ka: '6.0 Mg C Ha⁻¹ yr⁻¹',
              id: '6.0 Mg C Ha⁻¹ yr⁻¹',
              fr: '6.0 Mg C Ha⁻¹ yr⁻¹',
              es: '6.0 Mg C Ha⁻¹ yr⁻¹',
              en: '6.0 Mg C Ha⁻¹ yr⁻¹',
            },
            color: '#08431E',
          },
          {
            name: {
              zh: '',
              pt: '',
              ka: '',
              id: '',
              fr: '',
              es: '',
              en: '',
            },
            color: '#649D46',
          },
          {
            name: {
              zh: '0.06',
              pt: '0.06',
              ka: '0.06',
              id: '0.06',
              fr: '0.06',
              es: '0.06',
              en: '0.06',
            },
            color: '#F6F2C4',
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'CARBON_SEQ',
    type: 'imagery',
    url: 'https://tiles.globalforestwatch.org/gfw_potential_carbon_sequestration_rate/v1/aboveground__reforestable_areas/{z}/{x}/{y}.png',
    technicalName: 'carbon_sequestration',
    label: {
      en: 'Potential carbon sequestration rate',
      fr: 'Taux potentiel de séquestration du carbone',
      es: 'Tasa potencial de captura de carbono',
      pt: 'Taxa potencial de sequestro de carbono',
      id: 'Potensi tingkat penyerapan karbon',
      zh: '潜在的碳封存率',
      ka: 'Potential carbon sequestration rate',
    },
    sublabel: {
      en: '(reforestable areas, 1 kilometer, Cook-Patton et al. 2020)',
      fr: '(zones reboisables, 1 kilomètre, Cook-Patton et al. 2020)',
      es: '(áreas reforestables, 1 kilómetro, Cook-Patton et al. 2020)',
      pt: '(áreas de reflorestamento, 1 quilómetro, Cook-Patton et al. 2020)',
      id: '(area yang dapat dihutankan kembali, 1 kilometer, Cook-Patton et al. 2020)',
      ka: '(reforestable areas, 1 km, Cook-Patton et al. 2020)',
    },
  },
  isMetadataError: false,
  isError: false,
};
